import React from "react";
import meetingLogo from "../../assets/images/meeting.png";
const LoginImage = () => {
  document.body.classList.remove("landing-page");
  return (
    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 second-img-col">
      <div className="blue-box-cont">
        <div className="blue-box">
          <div className="slider-cont">
            <h2>MinutesVault</h2>
            <h6>Streamline Meetings, Boost Productivity</h6>
            <div className="white-box login-screen-img">
              <img
                // @ts-ignore
                src={meetingLogo}
                alt=""
              ></img>
            </div>
          </div>
        </div>
        <p className="copyright">
          &copy; 2025 MinutesVault. All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default LoginImage;
